import {AString} from '@mintdata/mint-kit/api/values/AString';

export enum SystemFont
{
    HELVETICA_NEUE = 'Helvetica Neue',

    ARIAL = 'Arial',
    TAHOMA = 'Tahoma',
    GEORGIA = 'Georgia',
    VERDANA = 'Verdana',
    COURIER_NEW = 'Courier New',
    TIMES_NEW_ROMAN = 'Times New Roman',
    TREBUCHET_MS = 'Trebuchet MS',
    COMIC_SANS_MS = 'Comic Sans MS',

    CALIBRI = 'Calibri',

    // google fonts

    ROBOTO = 'Roboto',
    ROBOTO_MONO = 'Roboto Mono',
    ROBOTO_CONDENSED = 'Roboto Condensed',

    MONTSERRAT = 'Montserrat',

    OPEN_SANS = 'Open Sans',
    OPEN_SANS_CONDENSED = 'Open Sans Condensed',
}

export class Typeface extends AString
{
    public constructor(value:AString)
    {
        super(value.toString());
        // super(value, Typeface.types);
    }

    // public toString():string
    // {
    // 	return this.value ? this.value.toString() : null;
    // }

    // public static ARIAL = new AString(SystemFont.ARIAL);
    // public static TAHOMA = new AString(SystemFont.TAHOMA);
    // public static VERDANA = new AString(SystemFont.VERDANA);
    // public static TIMES_NEW_ROMAN = new AString(SystemFont.TIMES_NEW_ROMAN);
    public static HELVETICA_NEUE = new AString(SystemFont.HELVETICA_NEUE);

    // public static types:Array<AString> = [
    // 	// Typeface.ARIAL,
    // 	// Typeface.TAHOMA,
    // 	// Typeface.VERDANA,
    // 	// Typeface.TIMES_NEW_ROMAN,
    // 	Typeface.HELVETICA_NEUE,
    // ];

    public static default():AString
    {
        return new AString(SystemFont.HELVETICA_NEUE);
    }

    // public static fromString(fontName:string):Typeface
    // {
    // 	return AString.fromString(fontName);
    // }
}
